export interface ChargeDetailSearchCriteria {

    cntrNos?: string[] | null,
    tariffCodes?: string[] | null,
    billToCompanies?: string[] | null,
    chargeOnCompanies?: string[] | null,
    bundleInds?: string[] | null,
    cntrSizes?: string[] | null,
    chargeTypes?: string[] | null,
    subChargeTypes?: string[] | null,
    bundleMasterNo?: string | null,
    cntrTypes?: string[] | null,
    adjTypes?: string[] | null,
    arrivalVesselCode?: string | null,
    arrivalVoyageCode?: string | null,
    statusCOKDs?: string[] | null,
    emptyInds?: string[] | null,
    operationTypes?: string[] | null,
    departureVesselCode?: string | null,
    departureVoyageCode?: string | null,
    specialHandlingInd?: string[] | null,
    specialHandlingIndD1?: string[] | null,
    cntrStatus?: string[] | null,
    docNo?: string | null,
    modalityArrivals?: string[] | null,
    modalityDepartures?: string[] | null,
    states?: string[] | null,
    opsLines?: string[] | null,
    marshallingTypes: string[] | null,
    displaySequence: number | null,
    handlingTmls?: string[] | null,
    vslCode?: string | null,
    voyCode?: string | null,
    chargeShareType?: string | null,
    chargeHdrId: number | null,
    poo: string | null,
    pol: string | null,
    pod: string | null,
    fd: string | null,
    forwarderShipperConsignees: string[] | null,
    chargeCodes: string[] | null,
    truckerName: string | null,
    cnicNo: string | null,
    vehicleNo: string | null,
    damageTypes: string[] | null,
    storageModes: string[] | null,
    oriStatus: string[] | null,
    newStatus: string[] | null,
    serviceOrderCode: string | null,
    serviceOrderNumber: string | null,
    serviceRequestCode: string | null,
    subServiceRequestCode: string | null,
    serviceRequestRef: string | null,
    opsDateFrom: Date | null,
    opsDateTo: Date | null,
    billOfLadingNo: string | null,
    shippingBill: string | null,
    agentNo: string | null,
    co?: string | null,
    vsl?: string | null,
    voy?: string | null,
    vel?: string | null,
    trainId?: string | null,
    [key: string]: string[] | string | boolean | number | Date | null | undefined
}

export const EMPTY_CHARGE_DETAIL_SEARCH_CRITERIA: ChargeDetailSearchCriteria = {
    chargeHdrId: 0,
    cntrNos: [],
    tariffCodes: [],
    billToCompanies: [],
    chargeOnCompanies: [],
    bundleInds: [],
    cntrSizes: [],
    chargeTypes: [],
    subChargeTypes: [],
    bundleMasterNo: null,
    cntrTypes: [],
    adjTypes: [],
    arrivalVesselCode: null,
    arrivalVoyageCode: null,
    statusCOKDs: [],
    emptyInds: [],
    operationTypes: [],
    departureVesselCode: null,
    departureVoyageCode: null,
    specialHandlingInd: [],
    specialHandlingIndD1: [],
    cntrStatus: [],
    docNo: null,
    modalityArrivals: [],
    modalityDepartures: [],
    states: [],
    opsLines: [],
    marshallingTypes: [],
    forwarderCodes: [],
    displaySequence: null,
    handlingTmls: [],
    vslCode: null,
    voyCode: null,
    chargeShareType: null,
    poo: null,
    pol: null,
    pod: null,
    fd: null,
    forwarderShipperConsignees: [],
    chargeCodes: [],
    truckerName: null,
    cnicNo: null,
    vehicleNo: null,
    damageTypes: [],
    storageModes: [],
    oriStatus: [],
    newStatus: [],
    serviceOrderCode: null,
    serviceOrderNumber: null,
    serviceRequestCode: null,
    subServiceRequestCode: null,
    serviceRequestRef: null,
    opsDateFrom: null,
    opsDateTo: null,
    billOfLadingNo: null,
    shippingBill: null,
    agentNo: null,
    co: null,
    vsl: null,
    voy: null,
    vel: null,
    trainId: null,
}